<template>
  <div class="charge-rule">
    <!-- <div class="content-left">
      <AreaTree ref="areaTree" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
              @change="reqParkingsByProperty(search.propertyId)"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="a_name">停车场：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.parkingId"
            >
              <el-option
                v-for="item in parkingsDataByProperty"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="a_name">卡类型：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.unitType"
            >
              <el-option
                v-for="item in unitTypes"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="form-group">
            <label for>规则名称:</label>
            <input
              clearable
              v-model="search.name"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div> -->
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add_btn"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <!-- <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="卡名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="卡类型"
           
          >
        <template slot-scope="scope">
          <span>{{ scope.row.unitType==1?'月卡':'年卡' }}</span>
        </template>
        </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="适用车场"
            prop="parkingNames"
          ></el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            label="卡名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="费用(月)"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="生效日期"
            prop="crtTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="卡类型"
       
          >
          <template slot-scope="scope">
            {{ scope.row.status==0?'待发布':(scope.row.status==1?'已发布':(scope.row.status==2?'已下线':'')) }}
          </template>
        </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <template slot-scope="scope">
              <button
                type="button"
            
                v-bind:class="[ 'edit',
                scope.row.status==1||scope.row.status==2 ? 'is-gray' : '',
               
              ]"
                @click="onReleaseBtn(scope.row.id)"
                :disabled="scope.row.status==1||scope.row.status==2"
              >
                发行
              </button>
              <button
                type="button"
                class="edit"
                @click="onDownlineBtn(scope.row.id)"
                v-bind:class="[ 'edit',
                scope.row.status==2 ? 'is-gray' : '',
               
              ]"
              :disabled="scope.row.status==2"
              >
                下线
              </button>
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row)"
              >
                修改
              </button>
              
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <!-- 添加/编辑收费规则-->
    <el-dialog
      title="添加/编辑收费规则"
      :visible.sync="dialogFormVisibleChargeRule"
      width="500px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      @close="closeDialog"
    >
      <el-form
        :rules="rules"
        :model="chargeRule"
        ref="formArea"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="会员卡名称" prop="name">
          <el-col :span="18">
            <el-input v-model.trim="chargeRule.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会员卡单位" prop="months">
          <el-col :span="18">
            <el-select v-model.trim="chargeRule.unitType">
              <el-option
                v-for="item in months"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >{{ item.label }}</el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="会员卡单价" prop="amount" class="price">
          <el-col :span="16">
            <el-input v-model.trim="chargeRule.amount"></el-input>
          </el-col>
          <el-col :span="2">
            <span>元</span>
          </el-col>
        </el-form-item>
        <el-form-item label="可选车型" prop="carType">
          <el-col :span="18">
            <el-checkbox-group v-model="checkedCarType">
              <el-checkbox
                v-for="carType in carTypes"
                :label="carType.value"
                :key="carType.labelDefault"
                >{{ carType.labelDefault }}</el-checkbox
              >
            </el-checkbox-group>
          </el-col>
        </el-form-item>
        <el-form-item label="物业" prop="parentId">
          <el-col :span="18">
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="chargeRule.parentId"
              @change="onPropertyChange"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="可停用车场" prop="parkingIds">
          <el-col :span="18">
            <el-select
              multiple
              clearable
              v-model="chargeRule.parkingIds"
              placeholder="请选择"
            >
              <el-option
                v-for="item in parkingsDataByProperty"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="卡片说明" prop="instruction">
          <el-col :span="18">
            <el-input
              type="textarea"
              v-model.trim="chargeRule.instruction"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="用户协议" prop="aggrement">
          <el-col :span="18">
            <el-input
              type="textarea"
              v-model.trim="chargeRule.aggrement"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="欠费车主购买" prop="arrearsCanBuy">
          <el-radio-group v-model.trim="chargeRule.arrearsCanBuy">
            <el-radio :label="1">允许</el-radio>
            <el-radio :label="0">不允许</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleChargeRule = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  getMonthlyChargeRule,
  getOneMonthlyChargeRule,
  addOrEditMonthlyChargeRule,
  getAllParkingsByEnabled,
  fetchPropertyList,
  dictValue,
  getParkingsByProperty,
  rentMonthPage,
  rentMonthRelease,
  rentMonthDownline
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  name:'charge-rule',
  data() {
    return {
      
      moduleName: "parking",
      propertyList: [],
      tableListData: [],
      allParkings: [],
      dialogFormVisibleChargeRule: false,
      months: [{label:'月',value:1},{label:'年',value:2}],
      search: {
        pageSize: 10,
        pageNumber: 1,
        name: '',
        propertyId: '',
        unitType:'',
        parkingId:'',
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      chargeRule: {
        name: "",
        parentId: "", //物业Id
        amount: "",
        instruction: "",
        aggrement: "",
        months: "",
        unitType:"",
        parkingIds: [],
        arrearsCanBuy: "",
        carType: [],
        id: "",
      },
      rules: {
        name: [{ required: true, message: "请填写规则名称", trigger: "blur" }],
        monthlyPrice: [
          { required: true, message: "请填写费用", trigger: "blur" },
        ],
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
      },
      checkedCarType: [],
      carTypes: [],
      parkingsDataByProperty: [],
      pageObj:{},
      unitTypes:[{
        value:1,
        name:'月'
    },{
        value:2,
        name:'年'
      }]
    };
  },
  components: {
    Page,
    AreaTree,
  },
  computed: {
    ...mapState(["page"]),
  },
  mounted:async function() {
   await this.getAllProperty();
   this.search.propertyId = this.propertyList[0].id;

    this.getCarTypes();
    this.tableList(this.search.pageNumber);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      var _this = this;
      const { propertyId, pageSize, name,parkingId,unitType } = this.search;
      this.$get(rentMonthPage(), {
        enabledFlag: "y",
        parentId: propertyId ? propertyId : null,
        limit: pageSize,
        page: curPage,
        name: name ? name : null,
        unitType:unitType ? unitType : null,
        parkingId:parkingId ?parkingId : null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          // if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
          //   item.propertyName = JSON.parse(item.parentId).name;
          // }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    addOrEdit(row) {
      
      if (!row) {
        this.dialogFormVisibleChargeRule = true;
        this.chargeRule = this.initChargeRule();
      } else {
        this.dialogFormVisibleChargeRule = true;
        this.chargeRule={...row};
        this.chargeRule.parkingIds=this.chargeRule.parkingIds.split(',')
        this.checkedCarType=this.chargeRule.carType.split(',')
        this.reqParkingsByProperty(this.chargeRule.parentId)
      
        // this.$get(getOneMonthlyChargeRule() + "/" + id).then((res) => {
        //   const {
        //     status,
        //     data
        //   } = res;
        //   if (status !== 200) return;
        //   this.chargeRule = {
        //   ...data
        //   };
        // });
      }
    },
    addEditTrue() {
      this.$refs["formArea"].validate((valid, noStri) => {
        if (valid) {
          const currentChargeRules = JSON.parse(
            JSON.stringify(this.chargeRule)
          );
          currentChargeRules.parkingIds = currentChargeRules.parkingIds.join(
            ","
          );
          currentChargeRules.carType = this.checkedCarType.join(",");
          if(currentChargeRules.unitType==1) currentChargeRules.months=1;
          if(currentChargeRules==2) currentChargeRules.months=12;
          // const { propertyId, monthlyPrice, name, id } = this.chargeRule;
          if (this.chargeRule.id) {
            this.$putRequest(getOneMonthlyChargeRule() + "/" + this.chargeRule.id, {
            ...currentChargeRules
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "月年租卡修改成功!",
              });
              this.tableList(this.page.curIndex);
            });
            this.dialogFormVisibleChargeRule = false;
          } else {
            this.$postRequest(getOneMonthlyChargeRule(), {
              ...currentChargeRules,
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "月年租卡设置成功!",
              });
              this.search.pageNumber = 1;
              this.tableList(this.search.pageNumber);
              this.dialogFormVisibleChargeRule = false;
            });
          }
        } else {
          return;
        }
      });
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this
            .$deleteRequest(getOneMonthlyChargeRule() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功!",
              });
              _this.tableList(_this.page.curIndex);
            });
        }
      );
    },
    allParking() {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return;
        this.allParkings = data.data.rows;
      });
    },
    searchList: function() {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    // resetForm() {
    //   this.$refs["formArea"].resetFields();
    // },
    closeDialog() {
      this.chargeRule = {
        name: "",
        parentId: "", //物业Id
        amount: "",
        instruction: "",
        aggrement: "",
        months: "",
        parkingIds: "",
        arrearsCanBuy: "",
        carType: [],
        id: null,
      };
      // this.resetForm();
    },
    getAllProperty() {
     return this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    getCarTypes() {
      this.$get(`${dictValue()}/car_type`).then((data) => {
     
        this.carTypes = data?.data?.rows ?? [];
      });
    },
    reqParkingsByProperty(id) {
    
      // this.search.parkingId=''
      this.$get(getParkingsByProperty(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) {
          return;
        }
        this.parkingsDataByProperty = data?.data ?? {};
      });
    },
    onPropertyChange(id) {
      this.reqParkingsByProperty(id);
    },
    initChargeRule() {
      return {
        name: "",
        parentId: "", //物业Id
        amount: "",
        instruction: "",
        aggrement: "",
        months: "",
        parkingIds: "",
        unitType:"",
        arrearsCanBuy: "",
        carType: [],
        id: "",
      };
    },
    onReleaseBtn(id){
      this.$postRequest(rentMonthRelease(),{
        id
      }).then(data=>{
       if(data?.status==200)  { 
         this.$message({
						message: '发布成功！',
						type: 'success'
						});
            this.tableList(this.page.curIndex);
            return;
					}
        if(data?.status!=200){
          this.$message({
						message: '发布失败！',
						type: 'waring'
						});
            return;
        }
      })
    },
    onDownlineBtn(id){
      this.$postRequest(rentMonthDownline(),{
        id
      }).then(data=>{
       if(data?.status==200)  { 
         this.$message({
						message: '下线成功！',
						type: 'success'
						});
            this.tableList(this.page.curIndex);
            return;
					}
        if(data?.status!=200){
          this.$message({
						message: '下线失败！',
						type: 'waring'
						});
            return;
        }
      })
    }
  },
};
</script>
<style scoped>
.charge-rule .is-gray{
  cursor: not-allowed;
  color:#aaa !important;
}
</style>
<style>
.charge-rule .price .el-form-item__content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.charge-rule .el-radio-group {
  margin-top: 10px;
}

</style>
